export { default } from './ScoredTableFaqs'
